import React from 'react';
import { NavigationManager } from './NavigationManager';
import { PsychosocialAvaliationProvider } from './context';

export function PsychosocialAvaliation() {
	return (
		<PsychosocialAvaliationProvider>
			<NavigationManager />
		</PsychosocialAvaliationProvider>
	);
}
